module.exports = __webpack_public_path__ + "media/photo/dev_old_man-b76b0660.png";